import { useState, useRef } from "react";
import { MoreButton } from "../../../../../UI-comp/ActionButtons.js";
import FriendMenuDropdown from "../Utils/FriendMenuDropdown.js";

import "../../../Styles/ua-common-styles.css";
import "../Styles/common-style.css";

const UFGridCentreUpperLayout = ({ 
  renderOperation, 
  setRenderOperation,
  friendsTab,
  setFriendsTab,
  selectedFriends = [],
  onFriendSelect
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const moreButtonRef = useRef(null);

  // ✅ Menu items for selected friends
  const menuItems = [
    {
      label: "🏫 Create Group",
      action: () => {
        if (selectedFriends.length === 0) {
          alert("Please select at least one friend to create a group");
          return;
        }
        console.log("Creating group with friends:", selectedFriends);
        alert(`Creating group with ${selectedFriends.length} friend(s):\n${selectedFriends.join(", ")}`);
        onFriendSelect([]);
      }
    },
    {
      label: "🗑️ Remove Friends",
      action: () => {
        if (selectedFriends.length === 0) {
          alert("Please select friends to remove");
          return;
        }
        const confirmed = window.confirm(
          `Are you sure you want to remove ${selectedFriends.length} friend(s)?`
        );
        if (confirmed) {
          console.log("Removing friends:", selectedFriends);
          onFriendSelect([]);
        }
      }
    },
    {
      label: "⭐ Mark as Priority",
      action: () => {
        if (selectedFriends.length === 0) {
          alert("Please select friends to mark as priority");
          return;
        }
        console.log("Marking as priority:", selectedFriends);
        alert(`Marked ${selectedFriends.length} friend(s) as priority`);
        onFriendSelect([]);
      }
    },
    {
      label: "🚫 Block Communication",
      action: () => {
        if (selectedFriends.length === 0) {
          alert("Please select friends to block");
          return;
        }
        const confirmed = window.confirm(
          `Block communication with ${selectedFriends.length} friend(s)?`
        );
        if (confirmed) {
          console.log("Blocking communication:", selectedFriends);
          onFriendSelect([]);
        }
      }
    },
    {
      label: "📧 Invite Members",
      action: () => {
        console.log("Invite Members clicked");
        alert("Invite Members");
      }
    },
    {
      label: "🚨 Report Abuse",
      action: () => {
        if (selectedFriends.length === 0) {
          alert("Please select friends to report");
          return;
        }
        console.log("Reporting abuse for:", selectedFriends);
        alert(`Reporting ${selectedFriends.length} friend(s)`);
      }
    },
  ];

  const handleMoreOptionClick = () => {
    console.log("More button clicked, toggling menu");
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleClearSelection = () => {
    onFriendSelect([]);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "0" }}>
      
      {/* ✅ MAIN CONTROL BAR - 20% LEFT | 60% CENTER | 20% RIGHT */}
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          gap: "16px",
          padding: "16px 20px",
          justifyContent: "space-between",
          backgroundColor: "black",
          borderBottom: "1px solid rgba(255,255,255,0.1)"
        }}
      >
        {/* LEFT SECTION - 20% */}
        <div style={{ flex: "0 0 20%", minWidth: "150px" }}>
          {/* Empty or can add additional controls here */}
        </div>

        {/* CENTER SECTION - 60% - Tab Buttons */}
        <div
          style={{
            flex: "0 0 60%",
            display: "flex",
            gap: "12px",
            justifyContent: "flex-start",
          }}
        >
          <span
            onClick={() => setFriendsTab("current")}
            style={{
              padding: "16px 32px",
              fontSize: "13px",
              fontWeight: "600",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "white",
              whiteSpace: "nowrap",
              alignContent: "center",
              marginLeft: 0,
              height: 50, 
              marginTop: 10,
              border: "1px solid var(--border-color, rgb(52, 51, 51))"
            }}
          >
            Current Friends
          </span>

          <button
            onClick={() => setFriendsTab("suggested")}
            style={{
              padding: "16px 32px",
              fontSize: "13px",
              fontWeight: "600",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              backgroundColor: "rgba(255,255,255,0.1)",
              color: "white",
              whiteSpace: "nowrap",
              marginLeft: 0,
              height: 50, 
              marginTop: 10,
              border: "1px solid var(--border-color, rgb(52, 51, 51))"
            }}
          >
            Suggested
          </button>

          {/* Search Bar */}
          <input
            type="text"
            placeholder="🔍 Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              flex: 1,
              padding: "16px 32px",
              borderRadius: "6px",
              border: "1px solid var(--border-color, rgb(52, 51, 51))",
              background: "rgba(255, 255, 255, 0.08)",
              color: "white",
              fontSize: "13px",
              outline: "none",
              transition: "all 0.3s ease",
              minWidth: "120px",
              height: 50, 
              marginTop: 10
            }}
          />
        </div>

        {/* RIGHT SECTION - 20% - More Button */}
        <div
          style={{
            flex: "0 0 20%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "relative",
            marginLeft: -60,
            marginTop: 10
          }}
          ref={moreButtonRef}
        >
          <MoreButton
            onClick={handleMoreOptionClick}
            aria-label="More options"
            aria-expanded={menuOpen}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "6px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              background: menuOpen ? "rgba(102, 126, 234, 0.2)" : "rgba(255, 255, 255, 0.08)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      </div>

      {/* Selection Counter Badge */}
      {selectedFriends.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: "rgba(102, 126, 234, 0.15)",
            padding: "10px 20px",
            borderBottom: "1px solid rgba(102, 126, 234, 0.3)",
            width: "fit-content",
            animation: "slideIn 0.3s ease",
          }}
        >
          <span style={{ color: "white", fontSize: "14px", fontWeight: "600" }}>
            {selectedFriends.length} Selected
          </span>
          <button
            onClick={handleClearSelection}
            style={{
              background: "transparent",
              border: "none",
              color: "#ff6b6b",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "600",
              padding: "4px 8px",
              borderRadius: "4px",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = "rgba(255, 107, 107, 0.2)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = "transparent";
            }}
          >
            ✕ Clear
          </button>
        </div>
      )}

      {/* Dropdown Menu */}
      <FriendMenuDropdown
        isOpen={menuOpen}
        onClose={handleCloseMenu}
        items={menuItems}
        className="custom-dropdown"
        anchorRef={moreButtonRef}
      />
    </div>
  );
};

export default UFGridCentreUpperLayout;
